import { useMemo, useState, useEffect, useRef } from "react";
// import AppBar from '@mui/material/AppBar';
import Toolbar from "@mui/material/Toolbar";
import useConfig from "hooks/useConfig";
import { useGetMenuMaster } from "api/menu";
import { getServerURL, getAppApiURL } from "../../../utils/serverUrl";
import {
  MenuOrientation,
  ThemeMode,
  DRAWER_WIDTH,
  MINI_DRAWER_WIDTH,
} from "config";

// project import
import AppBarStyled from "./AppBarStyled";
import HeaderContent from "./HeaderContent";

//context
import { useUserContext } from "contexts/UserContext";

// Service
import useDataSourceManager from "hooks/useDataSourceManager";

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const { menuOrientation } = useConfig();
  const { userState } = useUserContext();

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL;

  const [autoLogoutTime, setAutoLogoutTime] = useState(null);
  const timerRef = useRef(null);
  const serverURL = getServerURL();
  const serverApiURL = getAppApiURL();

  const [wsData, setWsData] = useState({
    uuid: "",
    response: {},
  });
  const { dataMap, getData, decodeTokenData, sendRequest, sendBatch } =
    useDataSourceManager(wsData);

  // Header content using useMemo to avoid unnecessary re-renders
  const headerContent = useMemo(() => <HeaderContent wsData={wsData} />, []);

  // Define the main header content
  const mainHeader = <Toolbar>{headerContent}</Toolbar>;

  const url = window.location.href;

  const blankKey = [
    "account/profile",
    "realm",
    "user_controller_invitation",
    "user_controller_expired",
    "user_controller_error",
    "invitation",
  ];
  let drawerPaddingWidth = blankKey.some((keyword) => url.includes(keyword))
    ? 0
    : MINI_DRAWER_WIDTH;

  const appBar = {
    position: "fixed",
    color: "inherit",
    elevation: 0,
    sx: {
      borderBottom: "1px solid",
      borderBottomColor: "divider",
      zIndex: 1200,
      width: isHorizontal ? "100%" : `calc(100% - ${drawerPaddingWidth}px)`,
    },
  };

  useEffect(() => {
    const fetchUserSetting = async () => {
      if (userState && process.env.REACT_APP_IS_MOCKUP === "false") {
        try {
          if (userState.properties?.auto_logout_time_limit) {
            setAutoLogoutTime(userState.properties.auto_logout_time_limit);
          }
        } catch (error) {
          console.error("Failed to fetch user setting:", error);
        }
      }
    };

    fetchUserSetting();
  }, [userState]);

  useEffect(() => {
    if (process.env.REACT_APP_IS_MOCKUP === "false" && autoLogoutTime) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      timerRef.current = setTimeout(async () => {
        try {
          const response = await sendRequest("casdoor/UserService/.logoutUser");
          if (response.status === "ok") {
            const token = localStorage.getItem("token");

            window.location.href =
              `${serverURL}/api/logout?id_token_hint=${encodeURIComponent(token)}` +
              `&post_logout_redirect_uri=${encodeURIComponent(`${serverApiURL}/login`)}`;
          }
        } catch (error) {
          console.error("Auto logout failed:", error);
        }
      }, autoLogoutTime * 1000);
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [autoLogoutTime]);

  return (
    <AppBarStyled open={drawerOpen} {...appBar}>
      {mainHeader}
    </AppBarStyled>
  );
}
